export enum ConfigureWorkflowWarningType {
  WORKFLOW = 'WORKFLOW',
  CREATIVE = 'CREATIVE',
  BOTH = 'BOTH'
}
